import {
  Box,
  Flex,
  Icon,
  Spacer,
  useDisclosure,
  Input,
} from "@chakra-ui/react";
import { Space, Table, TooltipProps } from "antd";
import type { TableProps as RcTableProps } from "rc-table/lib/Table";
import { get } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useFaqsMaster } from "../../store/faq/reducer";
import FaqsEditDrawer from "../drawer/FaqsEditDrawer";
import FaqDeleteModal from "../modals/FaqDeleteModal";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  ColumnsType,
  FilterValue,
  GetPopupContainer,
  SorterResult,
  TableCurrentDataSource,
  TableLocale,
  TablePaginationConfig,
  TableRowSelection,
} from "antd/lib/table/interface";
import { SizeType } from "antd/lib/config-provider/SizeContext";
import { RiDeleteBin6Line, RiEditLine, RiSearch2Line } from "react-icons/ri";
import FaqsDeleteConfirmation from "../modals/FaqsDeleteConfirmation";

export interface TableProps<RecordType>
  extends Omit<
    RcTableProps<RecordType>,
    | "transformColumns"
    | "internalHooks"
    | "internalRefs"
    | "data"
    | "columns"
    | "scroll"
    | "emptyText"
  > {
  dropdownPrefixCls?: string;
  dataSource?: RcTableProps<RecordType>["data"];
  columns?: ColumnsType<RecordType>;
  pagination?: false | TablePaginationConfig;
  loading?: boolean;
  size?: SizeType;
  bordered?: boolean;
  locale?: TableLocale;
  onChange?: (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<RecordType> | SorterResult<RecordType>[],
    extra: TableCurrentDataSource<RecordType>
  ) => void;
  rowSelection?: TableRowSelection<RecordType>;
  getPopupContainer?: GetPopupContainer;
  scroll?: RcTableProps<RecordType>["scroll"] & {
    scrollToFirstRowOnChange?: boolean;
  };
  sortDirections?: string[];
  showSorterTooltip?: boolean | TooltipProps;
}

interface Props {
  query: string;
}

const FaqsMasterTable: React.FC<Props> = ({ query }) => {
  const dispatch = useDispatch();
  const { masterFaqs, busy } = useFaqsMaster();
  console.log("mastersjfcnds", masterFaqs);

  const searchColumns = useMemo(() => ["answer", "question", "category"], []);

  const search = (query: string) => {
    return masterFaqs.filter((account: Record<string, any>) =>
      searchColumns.some((column) =>
        get(account, column, "")
          .toString()
          .toLowerCase()
          .includes(query.toLowerCase())
      )
    );
  };

  const [targetData, setTargetData] = useState<any>();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const {
    isOpen: isViewOpen,
    onOpen: onViewOpen,
    onClose: onViewClose,
  } = useDisclosure();

  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();

  const deletes = (record: any) => {
    setTargetData(record);
    onDeleteOpen();
  };

  const update = (record: any) => {
    setTargetData(record);
    onOpen();
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const filteredData = masterFaqs.filter((value: any, index: number) => ({
      _id: value._id,
      key: index + 1,
      Index: index + 1,
      answer: value.answer,
      category: value.category,
      question: value.question,
      hidden: value.hidden,
      value: value,
    }));
    setData(filteredData);
    setLoading(false);
  }, [masterFaqs, query]);

  const columns = [
    {
      title: "Nos.",
      dataIndex: "index",
      width: 60,
      render: (_: any, __: any, index: number) => `#${index + 1}`,
    },
    {
      title: "Questions",
      dataIndex: "question",
      width: 240,
    },
    {
      title: "Answer",
      dataIndex: "answer",
      width: 400,
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 150,
      render: (status: string) => (
        <span
          style={{
            width: "113px",
            height: "30px",
            padding: "6px 16px",
            borderRadius: "6px",
            backgroundColor:
              status === "publish"
                ? "rgba(2, 164, 50, 0.10)"
                : "rgba(212, 47, 47, 0.10)",
            color: status === "publish" ? "#02A432" : "#D42F2F",
            fontWeight: "400",
            fontSize: "14px",
          }}
        >
          {status}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      width: 100,
      render: (_: any, record: any) => (
        <Space size="middle">
          <RiEditLine
            style={{
              color: "#212121",
              cursor: "pointer",
              height: "20px",
              width: "20px",
            }}
            onClick={() => update(record)}
          />
          <RiDeleteBin6Line
            style={{
              color: "#212121",
              cursor: "pointer",
              height: "20px",
              width: "20px",
            }}
            onClick={() => deletes(record)}
          />
        </Space>
      ),
    },
  ];

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <>
      <div
        style={{
          width: "96vw",
          maxWidth: "96vw",
          maxHeight: "86vh",
          height: "86vh",
          top: "8vh",
          left: "4vw",
          overflowY: "auto",
          position: "relative",
          backgroundColor: "#EEEEEE",
          padding: "30px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Flex w="full" alignItems="center" justifyContent="space-between">
            {/* <Box
              display="flex"
              alignItems="center"
              bg="#ffffff80"
              border="1px solid #b2b2b233"
              borderRadius="8px"
              w="600px"
              p={1}
              sx={{
                "&:hover": {
                  border: "none", // Removes the border on hover
                },
                "&:focus-within": {
                  border: "none", // Removes the border if a child is focused
                },
              }}
            >
              <Box
                pl={2}
                display="flex"
                alignItems="center"
                color="#9E9E9E"
                fontSize="2xl"
              >
                <Icon as={RiSearch2Line} />
              </Box>

              <Box h="20px" w="1px" bg="#b2b2b2" mx={2} />

              <Input
                id="search"
                type="text"
                placeholder="Search or type a command"
                onChange={(e) => {
                  const filteredData = search(e.target.value);
                  setData(filteredData);
                }}
                style={{
                  fontSize: "small",
                  outline: "none",
                  border: "none",
                  background: "transparent",
                }}
                onFocus={(e) =>
                  ((e.target as HTMLInputElement).style.outline = "none")
                } // Removes outline on focus
                onMouseEnter={(e) =>
                  ((e.target as HTMLInputElement).style.border = "none")
                } // Removes border on hover
              />
            </Box> */}

            <Box
              display="flex"
              alignItems="center"
              bg="#FFF"
              border="1px solid #b2b2b233"
              borderRadius="12px"
              w="498px"
              padding="8px"
            >
              <Box
                pl={2}
                display="flex"
                alignItems="center"
                color="#9E9E9E"
                fontSize="2xl"
              >
                <img
                  src="/icons/searchlogo.svg"
                  alt="searchlogo"
                  style={{ height: "24px", width: "24px" }}
                />
              </Box>

              <Input
                id="search"
                type="text"
                placeholder="Search or type a command"
                onChange={(e) => {
                  const filteredData = search(e.target.value);
                  setData(filteredData);
                }}
                fontSize="sm"
                border="none"
                outline="none"
                color="#757575"
                _focus={{
                  border: "none",
                  outline: "none",
                  boxShadow: "none", // Add this line to remove the blue outline
                }}
                bg={"transparent"}
                style={{
                  outline: "none",
                  boxShadow: "none", // Add this line to ensure outline is removed in all browsers
                }}
              />
            </Box>

            <Spacer />

            <Box
              background="#E24441"
              fontSize={"sm"}
              color="#fff"
              w="fit-content"
              textAlign="center"
              p={3}
              cursor="pointer"
              borderRadius="8px"
              _hover={{ background: "#E24441" }}
              onClick={() => {
                onOpen();
                setTargetData(null);
              }}
            >
              + Add Faq
            </Box>
          </Flex>

          <Spacer></Spacer>

          <Table
            rowSelection={rowSelection}
            rowKey="key"
            columns={columns}
            dataSource={data}
            scroll={{ x: "max-content" }}
            size="middle"
            pagination={{
              position: ["bottomRight"],
              pageSize: 9,
            }}
            style={{
              backgroundColor: "white",
              borderRadius: 6,
            }}
            rowClassName={(record: any) => record.color}
            loading={busy && data.length === 0 ? true : false}
          />
        </div>
      </div>

      {isOpen && (
        <FaqsEditDrawer
          isOpen={isOpen}
          onClose={onClose}
          faqData={targetData}
        />
      )}

      {isDeleteOpen && targetData && (
        <FaqsDeleteConfirmation
          isOpen
          onClose={onDeleteClose}
          faqData={targetData}
        />
      )}
    </>
  );
};

export default FaqsMasterTable;
